import ActivityRadarMap from '@components/map/ActivityRadarMap';

const MapPage = () => {
  return (
    <div className="flex flex-col w-full bg-surface-50 dark:bg-surface-950 h-screen">
      <div className="flex-1 min-h-0 pb-16 lg:pb-0">
        <ActivityRadarMap />
      </div>
    </div>
  );
};

export default MapPage;
